import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Chat, Message } from '@/types'

export const useShareStore = defineStore('shareStore', () => {
  const messages = ref<Message[]>([])
  const chat = ref<Chat>()

  function setSharingInfo(newChat: Chat, newMessages: Message[]) {
    chat.value = newChat
    messages.value = newMessages
  }

  function reset() {
    chat.value = undefined
    messages.value = []
  }

  return {
    messages,
    chat,
    setSharingInfo,
    reset,
  }
})
